module.exports = __webpack_public_path__ + "static/media/corporate-services-img4.6e9377f5.jpg";